import {
  CopyOutlined,
  DeleteOutlined,
  DownloadOutlined,
  EditOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import {
  Button,
  Form,
  Input,
  Popconfirm,
  Spin,
  Table,
  Upload,
  message,
  Modal,
} from "antd";

import axios from "axios";
import { useEffect, useState } from "react";

const UploadDataDevelopment = () => {
  const [ApiData, setApiData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();
  const [isOpen, setIsOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [updateFile, setUpdateFile] = useState(null);
  const [ext, setExt] = useState(null);

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    setLoading(true);
    const environmentType = "/getUploadDevFiles";
    axios
      .get(process.env.REACT_APP_API_URL + environmentType)
      .then((result) => {
        let data = result.data;
        let newArr = [];
        data.forEach((x, i) => {
          newArr.push({
            no: i + 1,
            file: x.name,
            date_time: new Date(x.createdAt).toLocaleString(),
            action: x,
            id: x._id,
            fileLink: x.link,
          });
        });
        setApiData(newArr);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const downloadFile = (id) => {
    const environmentType = "downloadDevData";
    ApiData.forEach((x) => {
      if (id === x.id) {
        window.location.href = `${process.env.REACT_APP_API_URL}/${environmentType}/${x.fileLink}?token=WgMLYoPjS56HqtD`;
      }
    });
  };

  const copyDownloadFileLink = (id) => {
    const environmentType = "downloadDevData";
    ApiData.forEach((x) => {
      if (id === x.id) {
        let copyText = `${process.env.REACT_APP_API_URL}/${environmentType}/${x.fileLink}?token=WgMLYoPjS56HqtD`;
        navigator.clipboard.writeText(copyText);
        messageApi.open({
          type: "success",
          content: "Link has been copied to the clipboard",
        });
      }
    });
  };

  useEffect(() => {
    if (!selectedFile) {
      return;
    }
    const parts = selectedFile.link?.split(".");

    setExt(parts.length > 1 ? parts.pop().toLowerCase() : null);
  }, [selectedFile]);

  const handleDelete = (data) => {
    let data2 = {
      id: data._id,
      name: data.link,
    };
    setLoading(true);
    const environmentType = "/deleteUploadDevFiles";
    axios
      .post(process.env.REACT_APP_API_URL + environmentType, data2)
      .then((result) => {
        messageApi.open({
          type: "success",
          content: "File has been deleted",
        });
        getData();
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        messageApi.open({
          type: "error",
          content: err?.response?.data?.message || "Failed to delete",
        });
        console.log(err);
      });
  };

  const handleUpdate = async () => {
    try {
      if (!updateFile) {
        messageApi.warning("Please select a file");
        return;
      }
      setLoading(true);
      const formData = new FormData();

      formData.append("id", selectedFile._id);
      formData.append("myfile", updateFile);

      await axios.post(
        `${process.env.REACT_APP_API_URL}/updateUploadDevFiles`,
        formData,
      );

      messageApi.success("File updated successfully");

      setIsOpen(false);
      setSelectedFile(null);
      setUpdateFile(null);

      getData();
    } catch (err) {
      messageApi.error(err?.response?.data?.message || "Failed to update file");
    } finally {
      setLoading(false);
    }
  };

  const onFinish = (values) => {
    if (!values?.file?.fileList[0]?.originFileObj) {
      messageApi.open({
        type: "warning",
        content: "Please select file",
      });
      return;
    }
    setLoading(true);
    let data = new FormData();
    data.append("name", values.name);
    data.append("myfile", values.file.fileList[0].originFileObj);
    const environmentType = "/UploadDevFiles";
    axios
      .post(process.env.REACT_APP_API_URL + environmentType, data)
      .then((result) => {
        messageApi.open({
          type: "success",
          content: "File uploaded successfully",
        });
        getData();
        setLoading(false);
        form.resetFields();
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const onFinishFailed = ({ errorFields }) => {};

  const columns = [
    {
      title: "No",
      dataIndex: "no",
      key: "no",
    },
    {
      title: "File",
      dataIndex: "file",
      key: "file",
    },
    {
      title: "Date & Time",
      dataIndex: "date_time",
      key: "date_time",
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (data) => (
        <div style={{ cursor: "pointer" }}>
          <EditOutlined
            onClick={() => {
              setSelectedFile(data);
              setUpdateFile(null);
              setIsOpen(true);
            }}
            style={{
              marginRight: "10px",
              color: "#faad14",
              cursor: "pointer",
            }}
          />

          <DownloadOutlined
            onClick={() => downloadFile(data._id)}
            title="Download"
            style={{
              fontSize: "14px",
              color: "#167bff",
              marginRight: "10px",
            }}
          />
          <CopyOutlined
            onClick={() => copyDownloadFileLink(data._id)}
            title="Copy Link"
            style={{
              fontSize: "14px",
              color: "green",
              marginRight: "10px",
            }}
          />
          <Popconfirm
            title="Are you sure?"
            onConfirm={() => handleDelete(data)}
            okText="Yes"
            cancelText="No"
          >
            <DeleteOutlined style={{ fontSize: "14px", color: "red" }} />
          </Popconfirm>
        </div>
      ),
    },
  ];

  return (
    <div>
      <Modal
        title="Replace File"
        size="small"
        style={{ width: 300 }}
        open={isOpen}
        onOk={() => handleUpdate()}
        onCancel={() => {
          setIsOpen(false);
          setSelectedFile(null);
          setUpdateFile(null);
        }}
      >
        <Upload
          maxCount={1}
          fileList={updateFile ? [updateFile] : []}
          accept={ext ? `.${ext}` : null}
          beforeUpload={(file) => {
            setUpdateFile(file);
            return false;
          }}
        >
          <Button>Select Replacement File</Button>
        </Upload>
      </Modal>
      <Spin spinning={loading}>
        {contextHolder}
        <div style={{ marginBottom: "2rem" }}>
          <h3>Upload Files to Development</h3>
        </div>
        <div>
          <Form
            form={form}
            name="basic"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
            labelCol={{ span: 2 }}
            wrapperCol={{ span: 16 }}
          >
            <Form.Item
              label="File Name"
              name="name"
              rules={[
                {
                  required: true,
                  message: "Please input your File Name!",
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="File"
              name="file"
              rules={[
                {
                  required: true,
                  message: "Please upload a file!",
                },
              ]}
            >
              <Upload
                beforeUpload={() => false}
                listType="picture-card"
                maxCount={1}
              >
                <div>
                  <PlusOutlined />
                  <div style={{ marginTop: 8 }}>Select File</div>
                </div>
              </Upload>
            </Form.Item>

            <Form.Item wrapperCol={{ offset: 2, span: 16 }}>
              <Button type="primary" htmlType="submit">
                Upload File
              </Button>
            </Form.Item>
          </Form>
        </div>
        <div style={{ marginTop: "25px" }}>
          <Table columns={columns} dataSource={ApiData} rowKey="id" />
        </div>
      </Spin>
    </div>
  );
};

export default UploadDataDevelopment;
